import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhone } from 'react-icons/fa';

import ContactForm from './ContactForm';

function Contact() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <section className="contact" id="contact">
        <div className="container">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            Let's Build Your AI Advantage
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Proudly built in Los Angeles — supporting local businesses ready to compete globally.
            Start your automation journey with intelligent agents that deliver real results.
          </motion.p>
          <div className="contact-actions">
            <motion.button
              onClick={() => setIsFormOpen(true)}
              className="contact-button"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              Start Your Journey
            </motion.button>
            <motion.a
              href="tel:+14244344541"
              className="contact-phone"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <FaPhone style={{ marginRight: '10px' }} />
              AI demo: (424) 434-4541
            </motion.a>
          </div>
        </div>
      </section>

      <ContactForm
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
      />
    </>
  );
}

export default Contact;
